module.exports = [
  { // Gender
    question: {
      label: 'What is your gender, from birth?',
      prompt: 'gender'
    }, 
    input: 'radio',
    options: [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ]
  },
  { // Age
    question: {
      label: 'How old are you?',
      prompt: 'age'
    }, 
    input: 'radio',
    options: [
      { label: '35 or younger', value: '35 or younger' },
      { label: '36-50', value: '36-50' },
      { label: '51-65', value: '51-65' },
      { label: '66-80', value: '66-80' },
      { label: '81 or older', value: '81 or older' }
    ]
  },
  { // Pain
    question: {
      label: 'What level of pain are you feeling right now?',
      prompt: 'pain'
    },
    input: 'slider'
  },

  { // Trauma
    question: {
      label: 'Is this condition a result of recent trauma or injury?',
      prompt: 'trauma'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Past Treatments
    question: {
      label: `Mark any treatments you've had`,
      prompt: 'past_treatments'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Injection', value: 'injection' },
      { label: 'Physical Therapy', value: 'pt' },
      { label: 'Imaging (x-ray, MRI)', value: 'imaging' },
      { label: 'Surgery', value: 'surgery' },
      { label: 'None of the Above', value: 'none' },
    ]
  },
  { // Past Visits
    question: {
      label: `Have you had an evaluation by medical personnel?`,
      prompt: 'past_visits'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Primary Care', value: 'primary' },
      { label: 'Orthopedic', value: 'orthropedic' },
      { label: 'Emergency Care', value: 'er' },
      { label: 'Chiropractor', value: 'chiropractor' },
      { label: 'None', value: 'none' },
    ]
  },
  { // Pain Description
    question: {
      label: 'Is your pain acute and sharp, or a chronic dull pain?',
      prompt: 'pain_description'
    }, 
    input: 'radio',
    options: [
      { label: 'Dull Pain', value: 'dull' },
      { label: 'Sharp Pain', value: 'sharp' }
    ]
  },
  { // Swelling
    question: {
      label: 'Describe your swelling',
      prompt: 'swelling'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // Flex and Extend
    question: {
      label: `Mark all fingers you're unable to flex or extend normally`,
      prompt: 'extend_and_flex_fingers'
    }, 
    input: 'checkbox',
    options: [
      { label: 'All Extend Normally', value: 'all_normal' },
      { label: 'Thumb', value: 'thumb' },
      { label: 'Index', value: 'index' },
      { label: 'Middle', value: 'middle' },
      { label: 'Ring', value: 'ring' },
      { label: 'Pinky', value: 'pinky' },
    ]
  },
  { // Fingers Locking
    question: {
      label: `Mark any fingers that are locking`,
      prompt: 'fingers_locking'
    }, 
    input: 'checkbox',
    options: [
      { label: 'No Locking', value: 'none' },
      { label: 'Thumb', value: 'thumb' },
      { label: 'Index', value: 'index' },
      { label: 'Middle', value: 'middle' },
      { label: 'Ring', value: 'ring' },
      { label: 'Pinky', value: 'pinky' },
    ]
  },
  { // Numbness in Palm
    question: {
      label: 'Do you have numbness or tingling in the palm of your hand?',
      prompt: 'palm_numbness'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Numbness in Big Fingers
    question: {
      label: 'Do you have numbness or tingling in your thumb, index, or middle finger?',
      prompt: 'big_finger_numbness'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Numbness in Small Fingers
    question: {
      label: 'Do you have numbness or tingling in your ring or pinky finger?',
      prompt: 'small_finger_numbness'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Numbness in Back of Hand
    question: {
      label: 'Do you have numbness or tingling in the back of your hand?',
      prompt: 'backhand_numbness'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Wrist Bending
    question: {
      label: 'Can you bend your wrist normally?',
      prompt: 'bend_wrist'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'Limited', value: 'limited' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Pain Location
    question: {
      label: 'Where do you have elbow pain?',
      prompt: 'pain_location'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Medial (inside elbow)', value: 'medial' },
      { label: 'Lateral (outside elbow)', value: 'lateral' },
      { label: 'Across the Front/Bend', value: 'front' },
      { label: 'Back of Elbow', value: 'back' },
    ]
  }
]